export default __webpack_public_path__ + "mark-light.1e4373745fe9839b7b877628eeebf587.png";